(function () {
  var OPEN_PADDING_BOTTOM = 40;

  function ensureImagesLoad(answer) {
    var images = answer.querySelectorAll('img');
    var pending = [];
    images.forEach(function (img) {
      if (img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
      }
      if (!img.complete || img.naturalHeight === 0) {
        pending.push(img);
      }
    });
    return pending;
  }

  function recalcMaxHeight(item, answer) {
    if (!item.classList.contains('is-open')) return;
    answer.style.maxHeight = (answer.scrollHeight + OPEN_PADDING_BOTTOM) + 'px';
  }

  function openAnswer(item, button, answer) {
    var pendingImages = ensureImagesLoad(answer);

    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.style.maxHeight = (answer.scrollHeight + OPEN_PADDING_BOTTOM) + 'px';

    pendingImages.forEach(function (img) {
      var onDone = function () {
        recalcMaxHeight(item, answer);
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
      };
      img.addEventListener('load', onDone);
      img.addEventListener('error', onDone);
    });
  }

  function closeAnswer(item, button, answer) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    void answer.offsetHeight;
    answer.style.maxHeight = '0px';

    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
  }

  function initFaq() {
    var buttons = document.querySelectorAll('.kotei-faq__summary');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.kotei_faq_bound === '1') return;
      button.dataset.kotei_faq_bound = '1';

      var item = button.closest('.kotei-faq__item');
      if (!item) return;
      var answer = item.querySelector('.kotei-faq__answer');
      if (!answer) return;

      button.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          closeAnswer(item, button, answer);
        } else {
          openAnswer(item, button, answer);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
